import React, { PureComponent } from "react";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Container,
  Row,
  Table,
  Modal,
} from "reactstrap";
import { Field, reduxForm } from "redux-form";
import "./styles.css";
import EyeIcon from "mdi-react/EyeIcon";
import EmailIcon from "mdi-react/EmailIcon";
import AccountSearchIcon from "mdi-react/AccountSearchIcon";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import renderFileInputField from "../../../../shared/components/form/FileInput";
import renderSelectField from "../../../../shared/components/form/Select";
import renderMultiSelectField from "../../../../shared/components/form/MultiSelect";
import {
  MDBDataTable,
  MDBBtn,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
} from "mdbreact";
import axios from "axios";
import Select from "react-select";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import Util from "../../../Common/util";
import API from "../../../Common/api";
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';

/*import './styles.css';
 */
var url = window.location.hostname;
var port = window.location.port;
const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";

class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.toggle = this.toggle.bind(this);
    this.Errortoggle = this.Errortoggle.bind(this);
    this.handleFile1 = this.handleFile1.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.fetchGRNData = this.fetchGRNData.bind(this);
    this.btnClick = this.btnClick.bind(this);
    this.togglePressCancel = this.togglePressCancel.bind(this);
    this.showTypeahead = this.showTypeahead.bind(this);
    this.showTypeaheadChange = this.showTypeaheadChange.bind(this);
    this.closeContainer = this.closeContainer.bind(this);
    this.setBinId = this.setBinId.bind(this);
    this.onQuantityChange1 = this.onQuantityChange1.bind(this);
    this.processData = this.processData.bind(this);
    this.CancelErrorToggle = this.CancelErrorToggle.bind(this);
    this.ConfirmPutAway = this.ConfirmPutAway.bind(this);
    this.Successtoggle = this.Successtoggle.bind(this);
    this.CancelSuccessToggle = this.CancelSuccessToggle.bind(this);
    this.Confirmtoggle = this.Confirmtoggle.bind(this);
    this.CancelConfirmToggle = this.CancelConfirmToggle.bind(this);

    this.accessCookie = this.accessCookie.bind(this);
    this.handleFile2 = this.handleFile2.bind(this);
    /*this.showTypeahead = this.showTypeahead.bind(this);*/
    this.state = {
      showPassword: false,
      schemas: [],
      showFetchGRNData: false,
      rows: [],
      grnNumber: "",
      grnValues: "",
      selectedOptions: "",
      changeStatus: "",
      alertMessage: "",
      messageModal: false,
      postsGRN: [],
      postsProduct: [],
      tableRowsGRN: [],
      ErrorRowData: [],
      options: [],
      newArrayData: [],
      selectedUser: {},
      modal: false,
      Confirmmodal: false,
      ShowPrintLoader: false,
      loadingbtn: false,
      typeaheadText: "",
      pkd_val: "",
      lbskuid_val: "",
      mrp_val: "",
      quantity: "",
      defaultquantity: "",
      putawayHistoryId: "",
      showTypeahead: false,
      zwz_search_pannel: false,
      data: [],
      binId: "",
      hover_nod_data: [],
      showContainer: [],
      setBinIdLoop: {},
      splitData: [],
      Errormodal: false,
      Successmodal: false,
      ErrorMessage: "",
      SuccessMessage: "",
      loadingGRNValue: false,
      ShowExcelLoader: false,
    };
  }

  exportToCSV = (csvData, FileName) => {
    console.log(csvData);
    const arr = [];

    for (var i = 0; i < csvData.length; i++) {
      var orderData = {};
      orderData["Bin Address"] = csvData[i].binId;
      orderData["LB SKU ID"] = csvData[i].lbSkuId;
      orderData["LB SKU Product Name"] = csvData[i].lbSkuProductName;
      orderData["CBU Code"] = csvData[i].cbu;
      orderData["PKD"] = csvData[i].pkd;
      orderData["MRP"] = csvData[i].mrp;
      orderData["UPC"] = csvData[i].upc;
      orderData["Recieved ICLD Quantity"] = csvData[i].receivedIcldQty;
      orderData["Tester Quantity"] = csvData[i].testerQty;
      orderData["Loose Quantity"] = csvData[i].looseQuantity;
      orderData["Crate ID"] = csvData[i].crateId;
      orderData["Zone Name"] = csvData[i].zoneName;

      /*orderData['remarks'] = 'dfghjk';*/

      arr.push(orderData);
    }

    const ws = XLSX.utils.json_to_sheet(arr);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, FileName + fileExtension);
  };

  setBinId(item) {
    this.setState({
      typeaheadText: item,
    });
  }

  handleFile1() {
    this.setState({
      ShowPrintLoader: true,
    });
    console.log("sdfghjdfg");
    const payload = {
      id: localStorage.getItem("grnValues"),
      print: "grn",
      location: this.state.selectedLocation,
    };

    API.post("/picking/printSheet/v1/", { param: payload })

      .then((response) => {
        console.log(JSON.stringify(response.data));
        /*alert(response.data.success_response[0].message);
        this.fetchGRNData();*/
        var new_data = {};

        for (var i = 0; i < response.data.length; i++) {
          var tmp = response.data[i];
          if (new_data[tmp.userName] == undefined) {
            new_data[tmp.userName] = [response.data[i]];
          } else {
            new_data[tmp.userName].push(response.data[i]);
          }
        }

        console.log(new_data);
        localStorage.setItem("printData", JSON.stringify(new_data));
        console.log(localStorage.getItem("printData"));
        addAnalytics('Print Putaway', 'Print Putaway Details', this.state.data);

        /*window.location.href="/print_data";*/
        /* if (window.location.href="/putaway/printPutaway") {
           window.location.reload();
         }*/

        this.setState({
          loadingprintbtn: false,
          ShowPrintLoader: false,
          modal: false,
          showAssignButton: false,
          showPrintButton: true,
        });
        window.open("/PrintPutawayDetail", "_blank");
      })
      .catch(function (error) {});
  }

  componentWillMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    } else if (
      window.location.port == 8098 ||
      window.location.port === ":8098"
    ) {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8090";
    } else {
      url = window.location.hostname + port;
    }

    var cookieUsername = this.getCookie("token");
    var Location = this.getCookie("selectedLocation");
    var username = this.accessCookie("token");
    this.setState({
      userName: cookieUsername,
      selectedLocation: Location,
    });

    localStorage.setItem("userName", username);
  }

  createCookie(cookieName, cookieValue, daysToExpire) {
    var date = new Date();
    date.setTime(date.getTime() + 1 * 24 * 60 * 60 * 1000);
    document.cookie =
      cookieName + "=" + cookieValue + "; expires=" + date.toGMTString();
  }

  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(";");
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  CancelConfirmToggle() {
    this.setState({
      Confirmmodal: false,
    });
    window.location.reload();
  }

  onQuantityChange1(index, value) {
    const { rows } = this.state;
    this.setState({
      rows: rows.map((item, i) =>
        i === index ? { ...item, qty: value } : item
      ),
    });
  }

  handleFile2() {
    this.setState({
      ShowExcelLoader: true,
    });

    console.log("sdfghjdfg");
    const payload = {
      id: localStorage.getItem("grnValues"),
      print: "grn",
      location: this.state.selectedLocation,
    };

    API.post("/picking/printSheet/v1/", { param: payload })
      .then((response) => {
        console.log(JSON.stringify(response.data));
        this.setState({
          ShowExcelLoader: false,
        });
        this.exportToCSV(response.data, localStorage.getItem("grnValues"));

        /*alert(response.data.success_response[0].message);
        this.fetchGRNData();*/
        /*     var new_data = {};
     
             for(var i=0;i < response.data.length;i++){
                  var tmp = response.data[i];
                  if(new_data[tmp.userName] == undefined){
                      new_data[tmp.userName] = [response.data[i]];
                  }else{
                       new_data[tmp.userName].push(response.data[i]);
                  }
             
             }
     
             console.log(new_data);
             localStorage.setItem('printData' , JSON.stringify(new_data));
             console.log(localStorage.getItem('printData'));
     
           
     
             this.setState({
               loadingprintbtn: false,
               modal: false,
               showAssignButton: false,
               showPrintButton: true,
             })*/
      })
      .catch(function (error) {});
  }

  ConfirmPutAway() {
    console.log(this.state.postsGRN);
    this.setState({
      loadingbtn: true,
    });

    var arr = [];
    for (var i = 0; i < this.state.postsGRN.length; i++) {
      var orderData = {};
      orderData["putawayHistoryId"] = this.state.postsGRN[i].putawayHistoryId;
      orderData["location"] = this.state.selectedLocation;

      /*orderData['remarks'] = 'dfghjk';*/

      console.log(orderData);

      arr.push(orderData);
    }

    const payload = {
      arr_data: arr,
    };

    API.post("/picking/confirmPutaway/v1/", { param: payload })
      .then((response) => {
        console.log(response.data.success);
        /*this.setState({
            Successmodal: true,
          })*/

        this.setState({
          loadingbtn: false,
        });

        this.Confirmtoggle();

        /*window.location.reload();*/
        /* if (response.data[0].success= true) {
           this.setState({
             Successmodal: true,
           })

           window.location.reload();
         }*/
      })
      .catch(function (error) {});
  }

  CancelErrorToggle() {
    this.setState({
      Errormodal: false,
    });

    this.handleRemoveRow();
  }

  CancelSuccessToggle() {
    this.setState({
      Successmodal: false,
    });
  }

  CancelSuccessToggle() {
    this.setState({
      Successmodal: false,
    });
  }

  onBinChange1(index, value) {
    /*showTypeahead = (e) => {*/

    /*const data_val = ["B-W-R-2" , "C-D-T-3" , "C-D-T-8" , "C-D-T-8"];*/

    /*console.log(e.target.value);*/

    let { showContainer, rows } = this.state;
    showContainer[index] = true;
    this.setState(
      {
        showContainer,
        rows: rows.map((item, i) =>
          i === index ? { ...item, binId: value } : item
        ),
        /*data: data_val*/
      },
      () => {
        const payload = {
          location: this.state.selectedLocation,
          binAddress: value,
          putawayHistoryId: this.state.putawayHistoryId,
        };

        API.post("/picking/getBins/v1/", { param: payload })
          .then((response) => {
            console.log(response);
            this.setState({
              data: response.data,
            });
          })
          .catch(function (error) {});
      }
    );

    /*console.log(value);*/
  }

  setBinIdLoop(index, value) {
    const { rows, showContainer } = this.state;
    this.setState({
      rows: rows.map((item, i) =>
        i === index ? { ...item, binId: value } : item
      ),
      showContainer: showContainer.map((item, i) => false),
    });
  }

  hideTypeahead = (e) => {
    if (this.state.showTypeahead) {
      if (!this.typeahead.contains(e.target)) {
        this.setState({ showTypeahead: false });
      }
    }
  };

  handleAddRow = () => {
    this.setState((prevState, props) => {
      const row = {};
      return { rows: [...prevState.rows, row] };
    });
  };

  handleRemoveRow = () => {
    this.setState((prevState, props) => {
      return { rows: prevState.rows.slice(1) };
    });
  };

  handleRemoveRow1 = () => {
    this.setState((prevState, props) => {
      return {
        rows: prevState.rows.slice(6),
      };
    });
  };

  handleRemoveRow2 = () => {
    this.setState((prevState, props) => {
      return {
        rows: prevState.rows.slice(0),
      };
    });
  };

  showTypeaheadChange = (e) => {
    const value = e.target.value;
    this.setState({
      quantity: value,
    });
  };

  showTypeahead = (e) => {
    const value = e.target.value;
    this.setState(
      {
        typeaheadText: value,
      },
      () => {
        /*const data_val = ["B-W-R-2" , "C-D-T-3" , "C-D-T-8" , "C-D-T-8"];*/
        this.setState({
          showTypeahead: true,
          zwz_search_pannel: true,
          /* data: data_val*/
        });

        const payload = {
          location: this.state.selectedLocation,
          binAddress: value,
          putawayHistoryId: this.state.putawayHistoryId,
        };

        API.post("/picking/getBins/v1/", { param: payload })

          .then((response) => {
            console.log(response);
            this.setState({
              data: response.data,
            });
          })
          .catch(function (error) {});
      }
    );
  };

  closeContainer() {
    this.setState({
      showTypeahead: false,
    });
  }

  toggle() {
    this.setState((prevState) => ({ modal: !prevState.modal }));
  }

  Confirmtoggle() {
    this.setState((prevState) => ({ Confirmmodal: !prevState.Confirmmodal }));
  }

  Errortoggle() {
    this.setState((prevState) => ({ Errormodal: !prevState.Errormodal }));
  }

  Successtoggle() {
    this.setState((prevState) => ({ Successmodal: !prevState.Successmodal }));
  }

  showPassword = (e) => {
    e.preventDefault();
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  };

  togglePressCancel() {
    this.setState({
      modal: false,
    });
  }

  handleChange(event) {
    this.setState({
      value: event.target.data,
      grnValues: event.target.value,
    });

    console.log(this.state.grnValues);
    console.log(event.target.value);

    localStorage.setItem("grnValues", event.target.value);

    const payload = {
      id: event.target.value,
      print: "grn",
      location: this.state.selectedLocation,
    };

    API.post("/picking/printSheet/v1/", { param: payload })
      .then((response) => {
        console.log(JSON.stringify(response.data));
      })
      .catch(function (error) {});
  }

  componentDidMount() {
    const payload = {
      location: this.state.selectedLocation,
      grnType: 2,
    };

    API.post("/picking/fetchgrnList/v1/", { param: payload })
      .then((response) => {
        console.log(response);
        this.setState({
          schemas: response.data,
        });
      })
      .catch(function (error) {});

    /*this.fetchGRNData();*/
  }

  fetchGRNData() {
    var grnVal = localStorage.getItem("grnValues");
    this.setState({
      showFetchGRNData: true,
      loadingGRNValue: true,
    });

    const payload = {
      grnLineNumber: grnVal,
      grnType: 2,
    };

    API.post("/picking/fetchgrnInfo/v1/", { param: payload })
      .then((response) => response.data)

      .then((data) => {
        // console.log(data);

        // if (err) throw err;

        this.setState({ postsGRN: data });
      })

      .then(async () => {
        this.setState({
          tableRowsGRN: this.assemblePostsGRN(),
          isLoading: false,
          loadingGRNValue: false,
        });

        console.log(this.state.tableRowsGRN);
      });
  }

  assemblePostsGRN = () => {
    let postsGRN = this.state.postsGRN.map((post, index) => {
      return {
        /*grnNumber: post.grnNumber,

          gnrLineNumber: post.gnrLineNumber,*/

        /*putawayHistoryId: post.putawayHistoryId,*/
        /*status: post.status == 'UNHOLD' ? <MDBBtn onClick={r => this.btnClick(post.putawayHistoryId, post.status)} style={{backgroundColor: '#4ce1b6' , color: '#fff'}} color="default" rounded size="sm">Hold</MDBBtn> : <MDBBtn  style={{backgroundColor: '#de5361', color: '#fff'}} onClick={r => this.btnClick(post.putawayHistoryId, post.status)} rounded size="sm">Release</MDBBtn>,*/

        binId: post.binId,

        lbskuid: post.lbSKUId,

        zone_name: post.zoneName,

        zone_id: post.zoneId,

        batch: post.batch,

        mrp: post.mrp,

        receivedIcldQuantity: post.receivedIcldQuantity + " pcs",

        testerQuantity: post.testerQuantity + " pcs",

        /*looseQuantity: post.looseQuantity,*/

        stnDate: post.stnDate,

        stnNumber: post.stnNumber,

        pkd: post.pkd,

        upc: post.upc,
        total_quantity: post.binFilledQty + " pcs",

        /*grnDateTime: post.grnDateTime,*/

        /*basePackDesc: post.basePackDesc,*/

        fastMoving: post.fastMoving,

        crateId: post.crateId,

        action: (
          <span
            onClick={(r) =>
              this.btnClick(
                post.binId,
                post.receivedIcldQuantity,
                post.putawayHistoryId,
                post.upc,
                post.lbSKUId,
                post.mrp,
                post.pkd,
                post.binFilledQty
              )
            }
            style={{ cursor: "pointer", color: "#3ea3fc" }}
          >
            Edit
          </span>
        ),
      };
    });

    return postsGRN;
  };

  btnClick(binId, icldQuantity, PID, UPC, LBSKUID, MRP, PKD, totalQuantity) {
    this.setState({
      modal: true,
      typeaheadText: binId,
      quantity: icldQuantity,
      defaultquantity: icldQuantity,
      putawayHistoryId: PID,
      binId: binId,
      pkd_val: PKD,
      lbskuid_val: LBSKUID,
      mrp_val: MRP,
    });
    this.handleRemoveRow1();
  }

  processData() {
    var orderData = {};

    orderData["binAddress"] = this.state.typeaheadText;
    orderData["newPutawayQty"] = this.state.quantity;
    this.state.splitData.push(orderData);

    var total_Quantity = this.state.quantity;

    for (var i = 0; i < this.state.rows.length; i++) {
      var neworderData = {};
      neworderData["binAddress"] = this.state.rows[i].binId;
      neworderData["newPutawayQty"] = this.state.rows[i].qty;

      console.log(neworderData);

      total_Quantity =
        parseInt(total_Quantity) + parseInt(this.state.rows[i].qty);

      this.state.splitData.push(neworderData);
    }

    console.log(total_Quantity);

    /*if (this.state.defaultquantity < total_Quantity) {
      
      this.setState({
        ErrorMessage: 'Total quantity split exceeds the available quantity',
        Errormodal: true,
      })

      return false;
    }*/

    const payload = {
      putawayHistoryId: this.state.putawayHistoryId,
      newPutaway: this.state.splitData,
      location: this.state.selectedLocation,
    };

    API.post("/picking/splitPutaway/v1/", { param: payload })
      .then((response) => {
        console.log(response);

        if (response.data.success_response.length > 0) {
          this.setState({
            schemas: response.data,
            modal: false,
            Successmodal: true,
            ErrorMessage: "Successfully Updated",
            rows: [],
            splitData: [],
          });

          this.fetchGRNData();
        } else if (response.data.failure_response.length > 0) {
          this.handleRemoveRow2();
          this.setState({
            ErrorMessage: response.data.failure_response[0].reason,
            Errormodal: true,
            /*rows: [],*/
            splitData: [],
          });
        }

        console.log(this.state.rows);
      })
      .catch(function (error) {});

    /*console.log(this.state.splitData);*/
  }

  render() {
    const { handleSubmit, reset, t } = this.props;
    const { showPassword } = this.state;
    const { modal } = this.state;
    const { Errormodal } = this.state;
    const { Successmodal } = this.state;
    const { Confirmmodal } = this.state;

    const GRNData = {
      columns: [
        /* {
 
           label:'GRN Number',
 
           field:'grnNumber',
 
         },
 
         {
 
           label:'GRN Line Number',
 
           field:'gnrLineNumber',
 
         },*/

        /*{

          label:'PutAway History',

          field:'putawayHistoryId',

        },*/

        {
          label: "BIN Id",

          field: "binId",
          minimal: "lg",
        },

        {
          label: "LB SKU ID",

          field: "lbskuid",
          minimal: "lg",
        },

        {
          label: "Zone Name",

          field: "zone_name",
          minimal: "lg",
        },

        {
          label: "Zone Id",

          field: "zone_id",
          minimal: "lg",
        },

        {
          label: "Batch",

          field: "batch",
          minimal: "lg",
        },

        {
          label: "MRP",

          field: "mrp",
          minimal: "lg",
        },

        {
          label: "ICLD Quantity",

          field: "receivedIcldQuantity",
          minimal: "lg",
        },

        {
          label: "Tester Quantity",

          field: "testerQuantity",
          minimal: "lg",
        },

        /*{

          label:'Loose Quantity',

          field:'looseQuantity',
          minimal: 'lg'

        },*/

        {
          label: "STN Date",

          field: "stnDate",
          minimal: "lg",
        },

        {
          label: "STN Number",

          field: "stnNumber",
          minimal: "lg",
        },

        {
          label: "PKD",

          field: "pkd",
          minimal: "lg",
        },

        {
          label: "UPC",

          field: "upc",
          minimal: "lg",
        },

        {
          label: "Total Quantity",

          field: "total_quantity",
          minimal: "lg",
        },

        /*{

          label:'GRN Date Time',

          field:'grnDateTime',

        },*/

        /*{

          label:'Base Pack Desc',

          field:'basePackDesc',

        },*/

        {
          label: "Fast Moving",

          field: "fastMoving",
          minimal: "lg",
        },

        {
          label: "Crate Id",

          field: "crateId",
          minimal: "lg",
        },

        {
          label: "Action",

          field: "action",
          minimal: "lg",
        },
      ],

      rows: this.state.tableRowsGRN,
    };

    console.log(this.state.rows);

    return (
      <Col xl={12}>
        <Card>
          <CardBody>
            <div className="card__title">
              <h5 className="bold-text"></h5>
            </div>
            <form className="form form--inline">
              <div
                className="form__form-group col-xl-4"
                style={{ display: "inline-flex" }}
              >
                <span
                  className="form__form-group-label col-xl-5"
                  style={{ display: "none", paddingTop: 6, paddingBottom: 6 }}
                >
                  Select Putaway No.
                </span>

                <div
                  className="form__form-group-field col-xl-4"
                  style={{ display: "contents", marginBottom: "0px" }}
                >
                  <select
                    className="form-control"
                    value={this.state.value}
                    style={{ fontSize: 13 }}
                    onChange={this.handleChange}
                  >
                    <option value="0">Select GRN No.</option>
                    {this.state.schemas &&
                      this.state.schemas.length > 0 &&
                      this.state.schemas.map((schema) => {
                        return (
                          <option value={schema.grnLineNumber}>
                            {" "}
                            {schema.grnLineNumber}
                          </option>
                        );
                      })}
                  </select>
                </div>
              </div>

              <div
                className="form__form-group col-xl-3"
                style={{ marginBottom: "0px" }}
              >
                <div className="form__form-group-field">
                  <ButtonToolbar className="form__button-toolbar">
                    <Button
                      className="btn-sm button_enable "
                      style={{
                        borderRadius: 5,
                        backgroundColor: "#70bbfd",
                        color: "#fff",
                        textTransform: "capitalize",
                      }}
                      id="button_enable"
                      onClick={this.handleFile1}
                    >
                      {this.state.ShowPrintLoader && (
                        <i
                          className="fa fa-refresh fa-spin"
                          style={{ marginRight: "5px" }}
                        />
                      )}
                      Print
                    </Button>
                  </ButtonToolbar>
                  <span
                    className="pull-right"
                    onClick={this.handleFile2}
                    style={{
                      fontSize: "17px",
                      paddingRight: "0px",
                      cursor: "pointer",
                      color: "#999999",
                      marginLeft: "20px",
                      marginTop: "3px",
                    }}
                  >
                    <FontAwesomeIcon icon={faDownload}></FontAwesomeIcon>
                  </span>

                  {/*<ButtonToolbar className="form__button-toolbar">     
                    {this.state.ShowPrintLoader && 
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    }              

                     <button color="primary" className="btn-sm button_enable " style={{borderRadius: 5, backgroundColor:'#70bbfd', color:'#fff'}} id="button_enable" onClick={this.handleFile1}>
					 Print
					 </button>                
                
                </ButtonToolbar>*/}
                </div>
              </div>

              {/*<div className="form__form-group col-xl-3">
               
                <div className="form__form-group-field">
                  <ButtonToolbar className="form__button-toolbar">   
                    {this.state.ShowExcelLoader && 
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    }                   

                     <input value="Export to excel" color="primary" style={{backgroundColor: 'rgb(112, 187, 253)', color: '#fff', paddingTop: 7, paddingBottom: 7, paddingLeft: 25, paddingRight: 25}} className="btn-sm" onClick={this.handleFile2} type="button" />                
                
                </ButtonToolbar>

                 
                </div>
                
              </div>*/}
            </form>
            <div
              className="notes"
              style={{ paddingTop: "0px", paddingLeft: "15px" }}
            >
              <p style={{ marginBottom: "13px", fontSize: "15px" }}>
                <b>Note</b> : 1. Select the GRN number to print already assigned
                tasks.
              </p>
            </div>
          </CardBody>

          {this.state.showFetchGRNData && (
            <CardBody style={{ marginTop: 20 }}>
              <div className="table_header">
                <span>
                  {" "}
                  <span style={{ fontWeight: "bold" }}> GRN Number: </span>{" "}
                  <span> {this.state.grnValues} </span>
                </span>

                <ButtonToolbar className="form__button-toolbar">
                  <Button
                    color="primary"
                    className="btn-sm"
                    onClick={this.ConfirmPutAway}
                    type="submit"
                  >
                    {this.state.loadingbtn && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    Confirm
                  </Button>
                </ButtonToolbar>
              </div>

              <MDBTable scrollX={true} striped bordered>
                <MDBTableHead columns={GRNData.columns} />
                <MDBTableHead>
                  {this.state.loadingGRNValue && (
                    <div
                      style={{
                        width: "2300%",
                        textAlign: "center",
                        paddingTop: 22,
                      }}
                    >
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px", fontSize: 18 }}
                      />
                    </div>
                  )}
                </MDBTableHead>
                <MDBTableBody rows={GRNData.rows} />
              </MDBTable>
            </CardBody>
          )}
        </Card>

        <Modal
          isOpen={modal}
          toggle={this.toggle}
          style={{ maxWidth: 700, height: 500, padding: 0 }}
        >
          <div className="modal__header" style={{ backgroundColor: "#70bbfd" }}>
            <h4
              className="text-modal  modal__title"
              style={{ color: "#fff", paddingTop: 10 }}
            >
              Split Quantity
            </h4>
          </div>
          <div className="modal__body" style={{ marginTop: 10, padding: 16 }}>
            <div style={{ width: "100%" }}>
              <div style={{ width: "30%", float: "left", textAlign: "left" }}>
                <span style={{ fontSize: 15 }}>
                  <span style={{ fontWeight: "bold" }}> LB SKU ID: </span>{" "}
                  <span> {this.state.lbskuid_val} </span>{" "}
                </span>
              </div>

              <div style={{ width: "22%", float: "left", textAlign: "right" }}>
                <span style={{ fontSize: 15 }}>
                  <span style={{ fontWeight: "bold" }}> ICLD Qty: </span>{" "}
                  <span> {this.state.defaultquantity} </span>{" "}
                </span>
              </div>

              <div style={{ width: "22%", float: "left", textAlign: "right" }}>
                <span style={{ fontSize: 15 }}>
                  <span style={{ fontWeight: "bold" }}> PKD: </span>{" "}
                  <span> {this.state.pkd_val} </span>{" "}
                </span>
              </div>

              <div style={{ width: "25%", float: "left", textAlign: "right" }}>
                <span style={{ fontSize: 15 }}>
                  <span style={{ fontWeight: "bold" }}> MRP: </span>{" "}
                  <span> {this.state.mrp_val} </span>{" "}
                </span>
              </div>
            </div>

            <table className="table table-bordered table-hover" id="tab_logic">
              <thead style={{ textAlign: "left" }}>
                <tr>
                  <th>BIN</th>
                  <th>QTY</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ textAlign: "left" }}>
                    <div className="search-container">
                      <div className="react-search-field test-class">
                        <input
                          className="react-search-field-input"
                          placeholder="Search for Bearing No."
                          type="text"
                          style={{ padding: 4, borderRadius: 2 }}
                          defaultValue={this.state.typeaheadText}
                          value={this.state.typeaheadText}
                          onChange={this.showTypeahead}
                        />
                      </div>

                      {this.state.showTypeahead && (
                        <div
                          className="suggestions-container"
                          ref={(el) => (this.typeahead = el)}
                        >
                          {this.state.zwz_search_pannel && (
                            <div
                              className="suggestions"
                              onClick={this.closeContainer}
                            >
                              {this.state.data.length > 0 &&
                                this.state.data.map((item, index) => (
                                  <p
                                    key={index}
                                    onClick={() =>
                                      this.setBinId(item.binAddress)
                                    }
                                    className="typeahead-text"
                                  >
                                    {item.binAddress}{" "}
                                  </p>
                                ))}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </td>
                  <td style={{ textAlign: "left" }}>
                    <input
                      type="text"
                      value={this.state.quantity}
                      onChange={this.showTypeaheadChange}
                      style={{ padding: 4, borderRadius: 2 }}
                    />
                    <i
                      onClick={this.handleAddRow}
                      class="fa fa-plus-circle"
                      style={{
                        marginLeft: 15,
                        fontSize: 17,
                        cursor: "pointer",
                      }}
                    ></i>
                    <i
                      onClick={this.handleRemoveRow}
                      class="fa fa-minus-circle"
                      aria-hidden="true"
                      style={{
                        marginLeft: 15,
                        fontSize: 17,
                        cursor: "pointer",
                      }}
                    ></i>
                  </td>
                </tr>

                {this.state.rows.map((row, index) => (
                  <tr>
                    <td style={{ textAlign: "left" }}>
                      <div className="search-container">
                        <div className="react-search-field test-class">
                          <input
                            className="react-search-field-input"
                            placeholder="Search for Bin Address"
                            type="text"
                            style={{ padding: 4, borderRadius: 2 }}
                            value={row.binId}
                            onChange={(e) =>
                              this.onBinChange1(index, e.target.value)
                            }
                          />
                        </div>

                        {this.state.showContainer[index] && (
                          <div
                            className="suggestions-container"
                            ref={(el) => (this.typeahead = el)}
                          >
                            <div
                              className="suggestions"
                              onClick={this.closeContainer}
                            >
                              {this.state.data.length > 0 &&
                                this.state.data.map((item, i) => (
                                  <p
                                    key={i}
                                    onClick={() =>
                                      this.setBinIdLoop(index, item.binAddress)
                                    }
                                    className="typeahead-text"
                                  >
                                    {item.binAddress}{" "}
                                  </p>
                                ))}
                            </div>
                          </div>
                        )}
                      </div>
                    </td>
                    <td style={{ textAlign: "left" }}>
                      <input
                        type="text"
                        onChange={(e) =>
                          this.onQuantityChange1(index, e.target.value)
                        }
                        style={{ padding: 4, borderRadius: 2 }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <ButtonToolbar className="modal__footer">
              <button
                className="modal_cancel"
                onClick={this.togglePressCancel}
              >
                Cancel
              </button>
              <Button
                style={{
                  backgroundColor: "#24d6a3",
                  color: "#fff",
                  marginLeft: 12,
                }}
                className="modal_ok"
                onClick={this.processData}
              >
                Submit
              </Button>
            </ButtonToolbar>
          </div>
        </Modal>

        <Modal isOpen={Errormodal} toggle={this.Errortoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.Errortoggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-cross-circle modal__title-icon"
              style={{ color: "red" }}
            />
            <h4>{this.state.ErrorMessage} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.Errortoggle}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={Successmodal} toggle={this.Successtoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.Successtoggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-checkmark-circle modal__title-icon"
              style={{ color: "green" }}
            />
            <h4>Successfully Updated </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.CancelSuccessToggle}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={Confirmmodal} toggle={this.Confirmtoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.Confirmtoggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-checkmark-circle modal__title-icon"
              style={{ color: "green" }}
            />
            <h4>Successfully Updated </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.CancelConfirmToggle}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>
      </Col>
    );
  }
}

export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));
